var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.931,
    height: 34.93,
    viewBox: "0 0 34.931 34.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5790",
    "data-name": "Group 5790",
    transform: "translate(9376.494 -9257.498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_578",
    "data-name": "Ellipse 578",
    cx: 17.465,
    cy: 17.465,
    rx: 17.465,
    ry: 17.465,
    transform: "translate(-9376.494 9257.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M189.055,204.923V194.065H187.06V190.5h1.995v-2.307a3.932,3.932,0,0,1,4.231-4.231l3.109.013v3.461H194.14a.854.854,0,0,0-.889.973v2.1h3.2l-.365,3.562h-2.831v10.854Z",
    transform: "translate(-9550.782 9080.633)",
    fill: "#294da5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.558cde1b7b62bc2bdf44d0be23b1c2c9.svg";
export { ForwardRef as ReactComponent };